var map = {
	"./1426344.png": "5ef2",
	"./43205-200.png": "4974",
	"./Adobe-PDF-Document-icon.png": "3876",
	"./Delete.png": "97af",
	"./Dropdown_Icon.png": "393b",
	"./Find.png": "700d",
	"./Green_Urgent.png": "d876",
	"./Health_Tests.png": "a825",
	"./Human_body_features-nb.svg.png": "d627",
	"./New.png": "1cdd",
	"./OPD_ICON_1.png": "a90a",
	"./OPD_ICON_2.png": "406a",
	"./Office-excel-xls-icon.png": "8e86",
	"./Patient_appointment.png": "613b",
	"./PowerPoint-icon.png": "b53d3",
	"./Query.png": "be68",
	"./RED_Urgent.png": "da5c",
	"./Save.png": "c759",
	"./Search_Patient_1.png": "5a12",
	"./Simple_Heptagonal_Set_1-15-512.png": "f286",
	"./Sum.png": "842d",
	"./TEST1.png": "e400",
	"./Upload.png": "c31d",
	"./Wikiversity-Mooc-Icon-Edit.svg.png": "2db6",
	"./WorkW1.png": "6334",
	"./X-ray_1.png": "73e9",
	"./a-12-512.png": "69bb",
	"./add-button-hi.png": "17b6",
	"./analyzer2.png": "93d7",
	"./analyzer3.png": "4fb3",
	"./analyzer4.png": "03a2",
	"./appointment-calendar-date-deadline-due-meeting-schedule-7-31399.png": "4fec",
	"./av750c156ea54d77b97d4.png": "dca4",
	"./calendar-512.png": "e8d1",
	"./calendar-clipart-blue-9.png": "2fc0",
	"./calendar.png": "d392",
	"./chemistry.png": "989b",
	"./chemistry2.png": "4a3e",
	"./clock.png": "9126",
	"./close-512.png": "ead7",
	"./close-icon.png": "adb7",
	"./customer.png": "d765",
	"./default.png": "0b87",
	"./diamond.png": "d05b",
	"./diamond2.png": "94fe",
	"./doctor-icon.png": "0032",
	"./doctor-specialist-physician-512.png": "7267",
	"./download.png": "ceeb",
	"./edit-icon-2375785_960_720.png": "f1de",
	"./experiment-results.png": "d08f",
	"./eye-512.png": "4478",
	"./file.png": "41dc",
	"./file2.png": "a0f4",
	"./file_folder_document_search_find_scan-512.png": "656f",
	"./group.png": "b21f",
	"./heart-2658206_960_720.png": "4e23",
	"./icon-1691301_960_720.png": "7f00",
	"./icons8-join-480.png": "55cd",
	"./if_Add_39953.png": "1bf8",
	"./images.png": "3944",
	"./letter-h (1).png": "476e",
	"./letter-h.png": "9b84",
	"./letter-l (1).png": "52c1",
	"./letter-l.png": "71ac",
	"./letter-n.png": "8a03",
	"./medical-records.png": "afe7",
	"./medical-room.png": "aea2",
	"./medicine.png": "d76c",
	"./new-24-512.png": "8527",
	"./next.png": "95b2",
	"./patient_copy.png": "a85e",
	"./person-1205346_960_720.png": "fa51",
	"./picture.png": "f949",
	"./print-solid.png": "6f62",
	"./register.png": "ed2d",
	"./resolution-05-512.png": "f482",
	"./ruby.png": "8729",
	"./ruby2.png": "2f70",
	"./sandglass.png": "220e",
	"./search-icon-button-755412-3180392.png": "18a9",
	"./serum.png": "2d0d",
	"./service_icon_4.png": "44e2",
	"./sign-add-icon.png": "eab9",
	"./surgery.png": "3bef",
	"./trash.png": "5480",
	"./user.png": "dd09",
	"./verification.png": "ea4c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e358";